import { getBlockGapX } from '$lib/global/helper/layout';

import type { BrandSpacing, Theme } from '$lib/types/Theme';

export interface ResolvedCountdownStyling {
    textColor: string;
    separatorColor: string | undefined;
    gapClass: string | undefined;
}

interface Params {
    customColor: string;
    theme: Theme;
}

const resolveTextColor = (customColor: string, theme: Theme): string => {
    if (customColor && customColor !== 'transparent') {
        return customColor;
    }

    return theme.fontColor;
};

const resolveSeparatorColor = (theme: Theme): string | undefined => {
    if (theme.border && theme.border !== 'transparent') {
        return theme.border;
    }

    return undefined;
};

const resolveGapClass = (theme: Theme): string | undefined => {
    if (theme.blockGap) {
        return getBlockGapX(theme.blockGap as BrandSpacing);
    }

    return undefined;
};

export const resolveCountdownStyling = ({
    customColor,
    theme,
}: Params): ResolvedCountdownStyling => ({
    textColor: resolveTextColor(customColor, theme),
    separatorColor: resolveSeparatorColor(theme),
    gapClass: resolveGapClass(theme),
});
